import { ErrorBoundary } from "react-error-boundary"
import { useTranslation } from "react-i18next"
import PPUtils from "../../utils/PPUtils"

function goToLogin() {
    PPUtils.removeLogin()
    const base = (import.meta.env.BASE_URL || "/").replace(/\/$/, "")
    window.location.assign(`${base}/loginpage`)
}

function PPErrorFallback({ error, variant }) {
    const { t } = useTranslation()
    const titleKey =
        variant === "app"
            ? "errors.boundary_title_app"
            : variant === "page"
              ? "errors.boundary_title_page"
              : "errors.boundary_title"

    return (
        <div className={`pp-error-boundary pp-error-boundary--${variant} p-4`}>
            <h4 className="mb-2">{t(titleKey)}</h4>
            <p className="text-muted mb-3">{t("errors.boundary_hint")}</p>
            {import.meta.env.DEV && error?.message ? (
                <pre className="small text-muted mb-3" style={{ whiteSpace: "pre-wrap" }}>
                    {String(error.message)}
                </pre>
            ) : null}
            <div className="d-flex flex-wrap gap-2">
                <button type="button" className="btn btn-primary btn-sm" onClick={goToLogin}>
                    {t("errors.boundary_to_login")}
                </button>
                <a
                    className="btn btn-outline-secondary btn-sm"
                    href="https://youtrack.sylphen.com/form/750cc528-1ea6-4300-a793-c43ad4c82b58"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t("errors.boundary_to_helpdesk")}
                </a>
            </div>
        </div>
    )
}

export default function PPErrorBoundary({ children, resetKeys, variant = "section", onError }) {
    return (
        <ErrorBoundary
            resetKeys={resetKeys}
            onError={onError || ((error, info) => console.error(error, info?.componentStack))}
            fallbackRender={(props) => <PPErrorFallback {...props} variant={variant} />}
        >
            {children}
        </ErrorBoundary>
    )
}
